// extracted by mini-css-extract-plugin
module.exports = {"root":"TripCartPanelTitle_root__DXmVu","root_border":"TripCartPanelTitle_root_border__lYsIY","title":"TripCartPanelTitle_title__PJBs_","close":"TripCartPanelTitle_close__U03Br"};